import { ProcessFileType } from '../../convert/enums/process-file-type.enum';
import { DescribeProperty } from '../../common';

export class Model3dOutputResponse {
  @DescribeProperty({ description: 'The ID of model3d output', type: 'string', format: 'uuid' })
  id: string;

  @DescribeProperty({ description: 'File name', type: 'string' })
  fileName: string;

  @DescribeProperty({ description: 'File type', type: 'string', enum: ProcessFileType })
  fileType: ProcessFileType;

  @DescribeProperty({ description: 'File size', type: 'number' })
  fileSize: number;

  @DescribeProperty({ description: 'Url of the model3d output', type: 'string', format: 'url' })
  url: string;

  @DescribeProperty({
    description: 'Url of the model3d output for HEAD methods',
    type: 'string',
    format: 'url',
  })
  headUrl: string;

  @DescribeProperty({ description: 'Updated at', type: 'string', format: 'date-time' })
  updatedAt: Date;

  @DescribeProperty({ description: 'Created at', type: 'string', format: 'date-time' })
  createdAt: Date;
}
